import React from 'react';

const Simulator = () => {
    return (
        <div>
            <p>This is the Simulator</p>
        </div>
    );
};

export default React.memo(Simulator);